import * as React from 'react'

import { Map } from '../../../../app/maps/components/Map'
import { MAP_SUBTYPE_MANAGERS_FUNDS, MAP_TYPE_MANAGERS_FUNDS_WIDGET } from '../../../../app/maps/constants/constants'
import { SettingsScreener, SettingsScreenerDark } from '../../../../app/maps/constants/settings'
import { MapDataRoot } from '../../../../app/maps/types'
import { Heading } from '../../../components'

interface Props {
  data: MapDataRoot
}

const MapSettings = FinvizSettings.hasDarkTheme ? SettingsScreenerDark : SettingsScreener

export function HoldingsHeatmap({ data }: Props) {
  return (
    <div className="rounded-lg border border-primary p-2.5 pb-12.5">
      <Heading level={5} className="mb-2">
        Quarterly % Change in Holdings
      </Heading>
      <div className="h-96">
        <Map
          className="h-full"
          isFetchingPerf={false}
          isLoadingData={false}
          data={data}
          type={MAP_TYPE_MANAGERS_FUNDS_WIDGET}
          subtype={MAP_SUBTYPE_MANAGERS_FUNDS}
          dataHash={data?.hash}
          legend
          zoom={false}
          settings={MapSettings}
        />
      </div>
    </div>
  )
}
